import GooglePlayPolicyPolicy from './GooglePlayPolicy';

export default GooglePlayPolicyPolicy;